import * as types from '../const/action.types';
import { loadBasicInfo } from './session.actions';
import { get, put, post } from '../api/_basic';

export function loadClients() {
    return async (dispatch) => {
        dispatch(clientsHasErrored(false, ''));
        dispatch(clientsIsLoading(true));
        dispatch(loadBasicInfo());
        return get(`${process.env.REACT_APP_API_CLIENT}`)
            .then((response) => {
                dispatch(clientsIsLoading(false));
                return response;
            })
            .then((items) => {
                dispatch(clientsHasErrored(false, ''));
                dispatch(loadClientsSuccess(items));
            })
            .catch((error) => {
                dispatch(clientsIsLoading(false));
                dispatch(clientsHasErrored(error.type ? error.type : true, error.message));
            });
    };
}

export function addClient(client) {
    return async (dispatch) => {
        dispatch(clientIsSaving(true));
        return post(`${process.env.REACT_APP_API_CLIENT}`, client)
            .then((response) => {
                dispatch(clientIsSaving(false));
                if (response.error !== undefined) {
                    throw Error(response);
                }
                return response;
            })
            .then((items) => {
                return true;
            })
            .catch((error) => {
                console.log(error);
                throw error;
            });
    };
}

export function editClient(client) {
    return async (dispatch) => {
        dispatch(clientIsSaving(true));
        return put(`${process.env.REACT_APP_API_CLIENT}/${client.id}`, client)
            .then((response) => {
                dispatch(clientIsSaving(false));
                if (response.error !== undefined) {
                    throw Error(response);
                }
                return response;
            })
            .then((items) => {
                dispatch(loadBasicInfo());
                return true;
            })
            .catch((error) => {
                console.log(error);
                throw error;
            });
    };
}

export function loadInfo(id) {
    return async function(dispatch) {
        dispatch(clientsHasErrored(false, ''));
        dispatch(clientsIsLoading(true));
        return get(`${process.env.REACT_APP_API_CLIENT}/${id}`)
            .then((response) => {
                dispatch(clientsIsLoading(false));
                if (response.error !== undefined) {
                    throw Error(response);
                }
                return response;
            })
            .then((client) => {
                dispatch(clientsHasErrored(false, ''));
                dispatch(loadClientSuccess(client, null));
            })
            .catch((error) => {
                //throw error;
                dispatch(clientsHasErrored(error.type ? error.type : true, error.message));
            });
    };
}

export function loadClientSuccess(data, locals) {
    return {
        type: types.LOAD_CLIENT_SUCCESS,
        data,
        locals,
    };
}

export function loadClientsSuccess(data) {
    return {
        type: types.LOAD_CLIENTS_SUCCESS,
        data,
    };
}

export function clientsHasErrored(bool, message) {
    return {
        type: types.CLIENT_HAS_ERROR,
        hasErrored: bool,
        error: message,
    };
}

export function clientsIsLoading(bool) {
    return {
        type: types.CLIENTS_IS_LOADING,
        isLoading: bool,
    };
}

export function clientIsSaving(bool) {
    return {
        type: types.CLIENTS_IS_SAVING,
        isLoading: bool,
    };
}



// WEBPACK FOOTER //
// ./src/actions/client.actions.js